import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatDividerModule } from "@angular/material/divider";
import { MatListModule } from "@angular/material/list";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatTableModule } from "@angular/material/table";
import { MatSelectModule } from "@angular/material/select";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatChipsModule } from "@angular/material/chips";
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { MatRadioModule } from "@angular/material/radio";
import { LoaderModule } from "mis-crystal-design-system/loader";
import { LoginComponent } from "./authentication/components/login/login.component";
import { SsoLogoutComponent } from "./authentication/components/sso-logout/sso-logout.component";
import { SecurityHeaderInterceptor } from "./authentication/security-header.interceptor";
import { MatSlideToggleModule, _MatSlideToggleRequiredValidatorModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { AccessDeniedComponent } from './authentication/components/access-denied/access-denied.component';

@NgModule({
  declarations: [AppComponent, LoginComponent, SsoLogoutComponent, AccessDeniedComponent],
  imports: [
    MatInputModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    FormsModule,
    _MatSlideToggleRequiredValidatorModule,
    MatButtonModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatToolbarModule,
    MatMenuModule,
    MatIconModule,
    MatDividerModule,
    MatListModule,
    MatTableModule,
    MatSelectModule,
    MatCardModule,
    MatButtonModule,
    HttpClientModule,
    MatChipsModule,
    MatRadioModule,
    MatSnackBarModule,
    LoaderModule.forRoot(),
  ],
  providers: [
    HttpClientModule,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SecurityHeaderInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
